// URL du panel admin (sdn-admin) — sous-domaine séparé, sa propre API.
// Utilisé par tout composant qui consomme /api/banners/*, /api/gallery/*, etc.
export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || 'https://admin.sdn-nuisibles.fr';
